import { useMemo } from 'react';

import { useSessionStore } from '@/hooks/use-session-store/use-session-store';
import type { Contact } from '@/types/user-profile.type.ts';

export function useGetPersistedContact() {
  const {
    patientFirstName,
    patientLastName,
    contactPhoneNumber,
    contactEmail,
    representativeFirstName,
    representativeLastName,
    representativeRelationship,
    representativeAuthorizedForMedicalDecisions,
  } = useSessionStore();

  const contact: Contact = useMemo(
    () => ({
      firstName: representativeRelationship !== '' ? representativeFirstName : patientFirstName,
      lastName: representativeRelationship !== '' ? representativeLastName : patientLastName,
      phoneNumber: contactPhoneNumber,
      email: contactEmail,
      ...(representativeRelationship !== '' && {
        relationship: representativeRelationship as 'family-member' | 'non-family-caregiver',
      }),
      ...(representativeAuthorizedForMedicalDecisions !== '' && {
        authorizedForMedicalDecisions: representativeAuthorizedForMedicalDecisions === 'yes',
      }),
    }),
    [
      patientFirstName,
      patientLastName,
      contactPhoneNumber,
      contactEmail,
      representativeFirstName,
      representativeLastName,
      representativeRelationship,
      representativeAuthorizedForMedicalDecisions,
    ]
  );

  return contact;
}
